module.exports = __webpack_public_path__ + "static/media/Hikkaduwa.f56cb940.png";